export default __webpack_public_path__ + "static/media/earth.e9bbb39b.svg";